import SubscriptionPlanTitle from "%/dynamic-component-editor/standard-components/subscription-card/SubscriptionPlanTitle.vue";
import SubscriptionPlanBillingFrequency from "%/dynamic-component-editor/standard-components/subscription-card/SubscriptionPlanBillingFrequency.vue";
import SubscriptionPlanIncludedFeatures from "%/dynamic-component-editor/standard-components/subscription-card/SubscriptionPlanIncludedFeatures.vue";
import SubscriptionPlanExcludedFeatures from "%/dynamic-component-editor/standard-components/subscription-card/SubscriptionPlanExcludedFeatures.vue";
import SubscriptionPrice from "%/dynamic-component-editor/standard-components/subscription-card/SubscriptionPrice.vue";
import SubscriptionPlanAction from "%/dynamic-component-editor/standard-components/subscription-card/SubscriptionPlanAction.vue";
import SubscriptionPlanNote from "%/dynamic-component-editor/standard-components/subscription-card/SubscriptionPlanNote.vue";
import SubscriptionPlanDescription from "%/dynamic-component-editor/standard-components/subscription-card/SubscriptionPlanDescription.vue";
import LegacyEntity from "%/dynamic-component-editor/classes/LegacyEntity";

export default class LegacySubscriptionPlan extends LegacyEntity {
  get elements() {
    return {
      SubscriptionPlanTitle,
      SubscriptionPlanBillingFrequency,
      SubscriptionPlanIncludedFeatures,
      SubscriptionPlanExcludedFeatures,
      SubscriptionPrice,
      SubscriptionPlanAction,
      SubscriptionPlanDescription,
      SubscriptionPlanNote,
    };
  }
}
